// extracted by mini-css-extract-plugin
export default {"button":"EmojiButton_button__igMRs","selected":"EmojiButton_selected__u3L1y"};